<template>
  <div class="vertical-center">
     <vs-popup title="Change Serial Number" :active.sync="showNewMappingForm">
        <vs-input label="Serial Number" placeholder="Serial Number" v-model="serialNumber"/>
        <div id="btn-container">
          <vs-button class="btn-edit-sn" id="btn-edit-sn" @click="saveSerialNumber()" color="primary" type="gradient">Change Serial Number</vs-button>
        </div>
     </vs-popup>
     <vs-button @click="changeSerialNumber" class="float-left mr-2" type="filled" color="primary" size="small">Edit Serial Number</vs-button>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "DeviceRequestSerialNumber",
  data() {
    return {
      showNewMappingForm: false,
      serialNumber: "",
      rowIndex: 0,
    }
  },
  methods: {
    changeSerialNumber() {
      this.showNewMappingForm = true
    },
    saveSerialNumber() {
      if(!this.params.data.config.user){
        let hexstring = parseInt(Date.parse(this.params.data.created_at), 10).toString(16);
        let qrconfig = "AINO#0#" + this.serialNumber + `#` + hexstring + "#" + this.params.data.enc
        let payload = {
          index : this.params.data.id,
          data : this.params.data,
          code : this.params.data.code,
          value : qrconfig,
          serial_number: this.serialNumber,
          rowIndex: this.rowIndex
        }
        this.$root.$emit("get-config-DeviceRequestSerialNumber", payload)
        this.showNewMappingForm = false
      } else {
        const regex = /\/$/i;
        let baseURL = process.env.VUE_APP_SVD_API_URL
        baseURL = baseURL.replace(regex, '')
        let login_url = baseURL + process.env.VUE_APP_SVD_API_PORT + "/api/v1/auth/login"
        let provision_url = baseURL + process.env.VUE_APP_SVD_API_PORT + "/api/v1/devices/provision"
        let qrconfig = "AINO#0#" + this.serialNumber + `#{"login_url":"`+login_url+`","provision_url":"`+provision_url+`","email":"` + this.params.data.config.user.email + `","password":"` + this.params.data.config.user.password + `","device_code":"` + this.params.data.code + `", "serial_number":"` + this.params.data.serial_number + `"}`
        let payload = {
          index : this.params.data.id,
          data : this.params.data,
          code : this.params.data.code,
          value : qrconfig,
          serial_number: this.serialNumber,
          rowIndex: this.rowIndex
        }
        this.$root.$emit("get-config-DeviceRequestSerialNumber", payload)
        this.showNewMappingForm = false
      }
    }
  },
  mounted() {
    this.serialNumber = this.params.data.serial_number
    this.rowIndex = this.params.rowIndex
  }
})
</script>

<style scoped>
  .vs-con-input-label {width: 100%;}
  #btn-container {margin-top: 15px;}
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>